import TypingRole from "./TypingRole";
import SocialIcon from "./SocialIcon";
import Tag from "./Tag";
import { Download } from "lucide-react";
import BtnPrimary from "../ui/BtnPrimary";
import BtnSecondary from "../ui/BtnSecondary";

function HeroLeft({ bio, tags, socials }) {
  return (
    <>
      <div className="hero-left">
        <div className="hero-eyebrow">
          <TypingRole />
        </div>
        <h1 className="hero-name">
          Ricardo <span class="accent">Martins</span>
        </h1>
        <p className="hero-sub">// java • react • node.js • cloud • devops</p>
        <p className="hero-bio">{bio}</p>
        <div className="hero-tags">
          {tags.map((tag) => (
            <Tag text={tag.title} />
          ))}
        </div>
        <div className="hero-btns">
          <BtnPrimary text="View Projects" href="#projects" />
          <BtnSecondary
            text="Download CV"
            href="/Ricardo-Martins-CV.pdf"
            icon={<Download size={17} />}
            download
          />
        </div>
        <div className="hero-socials">
          <span>Let's connect:</span>
          {socials.map((social) => (
            <SocialIcon
              title={social.title}
              ref={social.ref}
              svgPath={social.svgPath}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default HeroLeft;
